export const GENDERS = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    UNKNOWN: 'UNKNOWN',
} as const;

export type Gender = keyof typeof GENDERS;
